export default __webpack_public_path__ + "static/media/Connectors.059b8b64.svg";